// Move the review badge into the price container and keep it there even if it
// renders late/updates after variant changes.
(() => {
  const right = document.querySelector('.detail .product-column-right');
  if (!right) return;

  function inlineStars() {
    const priceBox = right.querySelector('.price-container');
    const stars    = right.querySelector('.theme-product-reviews');
    if (!priceBox || !stars) return false;
    if (!priceBox.contains(stars)) {
      priceBox.appendChild(stars);
    }
    priceBox.classList.add('price-and-reviews--inline');
    return true;
  }

  // Try now; if not ready, observe for async widget render.
  if (!inlineStars()) {
    const obs = new MutationObserver(() => {
      if (inlineStars()) obs.disconnect();
    });
    obs.observe(right, { childList: true, subtree: true });
    // safety: one more attempt after a bit
    setTimeout(() => inlineStars() && obs.disconnect(), 4000);
  }

  // Re-inline after variant changes (some widgets re-render)
  document.addEventListener('change', e => {
    if (e.target && e.target.closest('variant-picker')) inlineStars();
  });
})();